class Menu {
  constructor() {
    // set height of child to be even with parent
    this.initEvents();
    this.setChildMenuHeight();
    this.resizeTimer = 0;
  }

  initEvents() {

    document.querySelectorAll('.popover-menu__link--2').forEach((item) => {

      item.addEventListener("mouseover", (e) => {
        this.toggleEl('.popover-menu__child-item', item.parentElement);
      });


    });
    document.body.addEventListener("click", (e) => {

      // Toggle the menu
      if( e.target.classList.contains('js-search') ) {
        e.preventDefault();
        document.body.classList.toggle('search-active');

        document.querySelector('.search-popover__search-input').focus();
      }


      // Toggle the submenu on main nav items click
      if( e.target.classList.contains('popover-menu__link--has-child') ) {
        e.preventDefault();
        this.toggleChildItemsMain(e);
      }

      // Toggle the back button
      if( e.target.classList.contains('js-menu-back-button') ) {
        e.preventDefault();
        this.backButton(e);
      }

      // Toggle the menu
      if( e.target.classList.contains('js-hamburger') ) {
        e.preventDefault();
        this.toggleMenu(e);
      }

      // Toggle the menu
      if( e.target.classList.contains('popover-menu__link--3') ) {
        setTimeout(function(){
          document.querySelector('.js-hamburger').click();
        }, 500);
      }

      // Toggle the menu
      if( e.target.classList.contains('js-chapters') ) {
        e.preventDefault();
        document.body.classList.toggle('chapters-menu-active');
        document.body.classList.remove('menu-active');
        e.target.classList.toggle('hamburger--collapse');
        e.target.classList.toggle('is-active');

        document.querySelector('.js-hamburger').classList.remove('is-actve');
      }
    });


    document.onkeydown = function(evt) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
          isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
          isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
        document.body.classList.remove('search-active');
      }
    };

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.setChildMenuHeight();
      }, 200);
    });
  }

  setChildMenuHeight() {
    document.querySelectorAll('.popover-menu__child').forEach((el) => {
      el.style.minHeight = document.querySelector('.popover-menu__list').scrollHeight+'px';
    });
  }

  toggleMenu(e) {
    let el = e.target;
    el.classList.toggle('is-active');
    document.querySelectorAll('.popover-menu__item').forEach((child) => {
      child.classList.remove('is-active');
    });

    if(!el.classList.contains('is-active')) {
      document.body.classList.remove('search-active');
    }

    // add menu-active to body to toggle menu
    document.body.classList.toggle('menu-active', el.classList.contains('is-active'));
    document.querySelector('.popover-menu').classList.remove('popover-menu--child-active');
  }

  backButton() {
    this.toggleEl();
  }

  toggleChildItemsMain(e) {
    let el = e.target.parentElement;
    //el.classList.toggle('is-active');
    this.toggleEl('.popover-menu__item', el);
    document.querySelector('.popover-menu').classList.add('popover-menu--child-active');
  }

  toggleChildItemsSub(e) {
    let el = e.target.parentElement;
    this.toggleEl('.popover-menu__child-item', el);
  }

  toggleEl(selector='.popover-menu__item', keepTarget=false) {
    document.querySelectorAll(selector).forEach((item) => {
      if(item !==keepTarget) {
        item.classList.remove('is-active');
      }
    });

    if(keepTarget) {
      keepTarget.classList.toggle('is-active');
    }
  }
}

new Menu();